angular.module('shared').factory('PingService', ["$rootScope", "$http", function($rootScope, $http) {
  return {
    ping: function() {
      var gymId, pingIntervalId, unsubscribe;
      gymId = $rootScope.gym.id;
      pingIntervalId = window.setInterval(function() {
        return $http.get(`/gyms/${gymId}/ping`);
      }, 120000);
      return unsubscribe = $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
        if (pingIntervalId) {
          window.clearInterval(pingIntervalId);
        }
        return unsubscribe();
      });
    }
  };
}]);
